/**
 * Parse a boolean-ish custom-element attribute (`open`, `default-open`).
 * `"true"` (or the bare attribute, `""`) is true, `"false"` is false, and an
 * absent or unrecognised value is `undefined` ("unset" - NOT false, so an absent
 * `open` leaves the widget uncontrolled).
 */
export function readBoolAttr(value: string | null): boolean | undefined {
  if (value === null) return undefined;
  if (value === "" || value === "true") return true;
  if (value === "false") return false;
  return undefined;
}
